import React from 'react';
import '../styles/Categories.css';

const Categories = () => (
  <div className="categories">
    <h1>Site Under construction!</h1>
  </div>
);

export default Categories;
